<template>
  <div :class="$style.wrapper">
    <div :class="$style.hint">
      <Hint>
        <p><slot/></p>
      </Hint>
    </div>
    <img :src="charImg" :class="$style.char">
  </div>
</template>
<script>
import Hint from '@/components/@ui/Hint/Hint.vue'

export default {
  name: 'HintChar',
  components: { Hint },
  props: {
    charImg: {
      type: String,
      default: require('./assets/char.svg'),
    },
  },
}
</script>
<style lang="scss" module>
@import './HintChar.scss';
</style>
